<template>
  <el-upload
    :drag="true"
    accept="image/*"
    ref="upload"
    action=""
    :multiple="false"
    :show-file-list="false"
    :on-success="handleAvatarSuccess"
    :before-upload="beforeAvatarUpload"
    class="upload-img"
  >
    <div>
      <slot />
    </div>
  </el-upload>
</template>

<script>
import bus from '@/util/bus.js'
import API from '@/api'
// 压缩图片插件
import ImageCompressor from 'js-image-compressor'
export default {
  props: {
    isCompress: {
      type: Boolean,
      default: true
    },
    page: {
      type: String,
      default: 'similar'
    }
  },
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
    },
    beforeAvatarUpload(file) {
      const isJPG = ['image/png', 'image/jpeg', 'image/webp'].includes(file.type)
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJPG) {
        this.$message.error(this.$t('customDetail.onlyPictures'))
        return
      }
      if (!isLt5M) {
        this.$message.error(this.$t('promptText.msg36'))
        return
      }
      let fr = new FileReader()
      fr.readAsDataURL(file)
      fr.onloadend = () => {
        this.imgUrl = fr.result
        sessionStorage.setItem('similar_base64', fr.result)
      }
      this.$emit('beforeUpload')
      if (this.isCompress) {
        this.imageCompressorHandle(file)
      } else {
        this.customProductGetSignValue(file)
      }
      return false
    },

    // 图片压缩
    imageCompressorHandle(file) {
      const self = this
      new ImageCompressor({
        file,
        quality: 0.8, // 压缩质量
        width: 280,
        height: 330,
        mimeType: file.type === 'image/webp' ? 'image/jpeg' : 'auto',
        success(result) {
          self.customProductGetSignValue(result)
        }
      })
    },

    // 获取阿里云文件服务器上传校验秘钥
    customProductGetSignValue(result) {
      API.customProductGetSignValue({ directory: this.page === 'ai' ? 'aiImage/' : this.page === 'pod' ? 'common/custom/images/' : 'baidusimilar/' }).then(({ data }) => {
        this.customProductUploadFile(data, result)
      })
    },

    // 图片上传
    customProductUploadFile(data, result) {
      const formData = new FormData()
      formData.append('directory', this.page === 'ai' ? 'aiImage/' : this.page === 'pod' ? 'common/custom/images/' : 'baidusimilar/')
      formData.append('signValue', data)
      formData.append('fileList', result)
      this.loading = true
      API.customProductUploadFile(formData).then(({ data }) => {
        if (this.page === 'ai') {
          this.$emit('uploadSuccess', data)
        } else if (this.page === 'pod') {
          this.$emit('uploadSuccess', data, result)
        } else {
          sessionStorage.setItem('similar_img', data)
          location.href = '/mall/similar'
          // this.$router.push('/mall/similar')
          this.$emit('uploadSuccess')
          this.$nextTick(() => {
            bus.$emit('getStorage')
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-img {
  /deep/ .el-upload-dragger{
    width: unset;
    height: unset;
    background-color: unset;
    border: 0;
    border-radius: unset;
  }

}
</style>
